import * as Yup from 'yup';

export const MIN_IBAN_LENGTH = 15;

export const BANK_ACCOUNT_REVIEW_STATUSES = {
  pending: 'pending',
  rejected: 'rejected',
  approved: 'approved',
  deleted: 'deleted',
};

export const VALIDATION_SCHEMA = t =>
  Yup.object({
    country: Yup.mixed().required(t('validation:val_country_is_required')),
    beneficiary_name: Yup.string().required(
      t('validation:val_beneficiary_name_is_required'),
    ),
    in_sepa_zone: Yup.boolean(),
    is_valid_sepa: Yup.boolean().oneOf(
      [true],
      t('validation:val_iban_is_invalid'),
    ),
    account_number: Yup.string().required(t('validation:val_iban_is_required')),
    files: Yup.array()
      .min(1, t('validation:val_bank_statement_required_field'))
      .required(t('validation:val_bank_statement_required_field')),
    swift: Yup.string().when('in_sepa_zone', {
      is: isSepa => isSepa !== true,
      then: () =>
        Yup.string().required(t('validation:val_swift_bic_code_is_required')),
    }),
    beneficiary_address: Yup.string().when('in_sepa_zone', {
      is: isSepa => isSepa !== true,
      then: () =>
        Yup.string().required(t('validation:val_address_is_required')),
    }),
    beneficiary_bank: Yup.string().when('in_sepa_zone', {
      is: isSepa => isSepa !== true,
      then: () =>
        Yup.string().required(t('validation:val_bank_name_is_required')),
    }),
    beneficiary_bank_address: Yup.string().when('in_sepa_zone', {
      is: isSepa => isSepa !== true,
      then: () =>
        Yup.string().required(t('validation:val_bank_address_is_required')),
    }),
  });
